
import { baseUrl } from "../../constants";

export default {
    "formTitle": "Add Job Status",
    "tableTitle": "Job Status List",
    "apiDetails": {
        startUp: () => {
        },
        list: {
            url: `${baseUrl}/api/mms/job_status/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/job_status`,
        edit: `${baseUrl}/api/mms/job_status/edit`,
        delete: `${baseUrl}/api/mms/job_status/remove`
    },
    "tableCol": [
        {
            name: 'Job Status',
            selector: row => row.name,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Job Status',
                    name: 'name',
                    "required": true
                }
            ]
        }
    ],
    "mockData": [{
        "name": "12"
    }]
}